import { Stack, styled, type StackProps } from '@mui/material';

const StyledRoot = styled(Stack)(({ theme }) => ({
  flexGrow: 1,
  display: 'flex',
  padding: theme.spacing(1),
  backgroundColor: theme.palette.background.neutral,
})) as typeof Stack;

export type ModalBodyContainerProps = StackProps;

export const ModalBodyContainer = (props: ModalBodyContainerProps) => <StyledRoot {...props} />;
